module.exports = __webpack_public_path__ + "static/img/kv.b065010.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/kv.jpg
// module id = xBzX
// module chunks = 7